import styled from 'styled-components';
import { PaginatorStyled } from '../PaginatorStyled';

export const PaginatorStyledOV = styled(PaginatorStyled)`
    .pagination {
        li {
            a {
                color: ${({ theme }) => theme.colors.black};
                text-decoration: none;
                background-color: ${({ theme }) => theme.colors.white};
            }
            &.active a {
                color: ${({ theme }) => theme.colors.white};
                background-color: ${({ theme }) => theme.colors.black};
                border-color: ${({ theme }) => theme.colors.black};
            }
        }
    }
`;
